import { getApiKey } from "../../utils/apiKey";
import React, { useState, useEffect } from "react";
import { Autoplay } from "swiper/modules";
import { apiCall_domain } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import { Link, useHistory } from "routerCompat";
import { Swiper, SwiperSlide } from "swiper/react";
import { Box, Modal } from "@mui/material";
import toast from "react-hot-toast";
import { RequestItem } from "../mainPage/RequestItem";

const HomePage = () => {
  const [notifications, setNotifications] = useState(null);
  const [loading, setLoading] = useState(true);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [modal, setModal] = useState(false);
  const [data, setData] = useState(null);
  const [splash, setSplash] = useState(null);
  const [service, setService] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [carCategoryTitle, setCarCategoryTitle] = useState("");
  const [description, setDescription] = useState("");
  const [showModal, setShowModal] = useState(false);

  const selectBrand = (brandId) => {
    setSelectedBrand(brandId);
  };

  const selectModel = (brandId) => {
    setSelectedModel(brandId);
  };

  const handleCarCategoryTitle = (title) => {
    setCarCategoryTitle(title);
  };

  const handleDescription = (description) => {
    setDescription(description);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    axios
      .get(`${apiCall_domain}/customer/requested_items`, {
        headers: Headers,
      })
      .then((res) => setBrands(res.data.data));
  }, []);

  useEffect(() => {
    const Headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    if (selectedBrand) {
      axios
        .get(
          `${apiCall_domain}/customer/requested_items?cat_id=${selectedBrand}`,
          {
            headers: Headers,
          },
        )
        .then((res) => setModels(res.data.data));
    }
  }, [selectedBrand]);

  const submitRequest = () => {
    const splash = localStorage.getItem("splash");
    const parsedSplash = JSON.parse(splash);
    const Headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    const data = {
      car_category_id: selectedBrand,
      car_id: selectedModel,
      user_phone: parsedSplash.customer_info.phone,
      car_category_title: carCategoryTitle,
      description: description,
    };
    if (
      data.car_category_id &&
      data.car_id &&
      data.description &&
      data.car_category_title
    ) {
      axios
        .post(`${apiCall_domain}/customer/store_requested_items`, data, {
          headers: Headers,
        })
        .then(() => {
          setModal(false);
          setShowModal(true);
        });
    } else {
      toast.error("تمامی فیلد های مورد نظر را پر کنید");
    }
  };

  const history = useHistory();

  useEffect(() => {
    localStorage.setItem("lat", "");
    localStorage.setItem("lng", "");
    localStorage.setItem("categoryIdMultiVnedor", "");
    localStorage.setItem("categoryTitleMultiVnedor", "");
    localStorage.setItem("CategoryChildListId", "");

    const Headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };

    const splashData = localStorage.getItem("splash");
    if (splashData) {
      setCustomerInfo(JSON.parse(splashData)?.customer_info);
    }

    const fetchData = async () => {
      try {
        const serviceRes = await axios.get(
          `${apiCall_domain}/customer/mechanics/services`,
          { headers: Headers },
        );
        setService(serviceRes.data.data);

        const customerRes = await axios.get(
          `${apiCall_domain}/customer/index?city_id=${
            JSON.parse(splashData)?.customer_info?.city?.id
          }`,
          { headers: Headers },
        );
        setData(customerRes.data);

        const splashRes = await axios.get(`${apiCall_domain}/customer/splash`, {
          headers: Headers,
        });
        localStorage.setItem("CAN_PAY_CASH", splashRes.data.CAN_PAY_CASH);
        localStorage.setItem("splash", JSON.stringify(splashRes.data));
        setNotifications(splashRes.data.notifications);
        setSplash(splashRes.data);

        checkLoadingStatus(
          serviceRes?.data?.data?.length,
          splashRes.data,
          customerRes.data,
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const checkLoadingStatus = (serviceLength, splashData, customerData) => {
    if (customerData && splashData && serviceLength) {
      setLoading(false);
    }
  };

  const extractPurePersianWords = (str) => {
    if (str === null || str === "") return false;
    return str
      .toString()
      .match(/[\u0600-\u06FF]+/g)
      .join(" ");
  };

  const citySelection = () => {
    history.push({
      pathname: "/citySelection",
      pushHome: history,
    });
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="homepageCom">
          <span className="Logo" id="Logo">
            <img src="/public/assets/logo.svg" alt="عکس" />
            <div className="user-container">
              {showModal && (
                <div className="requestModal">
                  <div className="requestModalContent">
                    <img src="/public/assets/img/homepage/checkmark.svg" />
                    <p>
                      درخواست شما با موفقیت ثبت شد! تا دقایقی دیگر کارشناسان ما
                      با شما تماس میگیرند. پیشاپیش از بردباری شما ممنونیم.
                    </p>
                    <span className="requestModalClose" onClick={closeModal}>
                      باشه
                    </span>
                  </div>
                </div>
              )}
              <div className="city-container">
                {customerInfo ? (
                  <span onClick={citySelection}>{customerInfo.city.name}</span>
                ) : (
                  <span onClick={citySelection}>
                    لطفا شهر خود را انتخاب نمایید
                  </span>
                )}
                <i className="icon-chevron-left" />
              </div>
              <Link to={"/profile"} className="user">
                <i className="icon-user-outline" />
              </Link>
            </div>
          </span>
          <div className="head">
            <Swiper
              slidesPerView={1}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              modules={[Autoplay]}
              spaceBetween={24}
            >
              {data?.sliders?.map((slide) => (
                <SwiperSlide key={slide.id}>
                  <img className="slide" src={slide.pic} alt="slide" />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          {modal ? (
            <Modal open={modal} onClose={() => setModal(false)}>
              <Box
                style={{
                  height: "100%",
                  background: "#fff",
                }}
              >
                <div onClick={() => setModal(false)} className="modalHeader">
                  <i className="icon-chevron-left" />
                </div>
                <RequestItem
                  data={brands}
                  models={models}
                  methods={{
                    selectBrand,
                    selectModel,
                    handleCarCategoryTitle,
                    handleDescription,
                    submitRequest,
                  }}
                />
              </Box>
            </Modal>
          ) : null}

          <div className="info-container">
            <div
              onClick={() => {
                window.Goftino.open();
              }}
              className="info-item"
            >
              <img src="public/assets/index/1.svg" alt="عکس" />
              <span>پشتیبانی</span>
            </div>
            <Link
              to={"https://kacharlife.com/sellerinfo"}
              className="info-item"
            >
              <img src="public/assets/index/2.svg" alt="عکس" />
              <span>تامین کنندگان</span>
            </Link>
            <Link to={"/customerclub"} className="info-item">
              <img src="public/assets/index/3.svg" alt="عکس" />
              <span>باشگاه مشتریان</span>
            </Link>
            <Link to={"/profile/Wallet"} className="info-item">
              <img src="public/assets/index/4.svg" alt="عکس" />
              <span>کیف پول</span>
            </Link>
          </div>
          <Link to={"/carSelection"} className="car-info">
            <span>اطلاعات خودرویی خود را ثبت کنید</span>
            <img src="public/assets/index/car-num.svg" alt="عکس" />
          </Link>
          <div className="categories" id="categories">
            <span>دسته بندی ها</span>
            <div>
              <Swiper
                slidesPerView={4}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay]}
                spaceBetween={12}
              >
                {data?.categories?.map((slide) => (
                  <SwiperSlide key={slide.id}>
                    <Link className="category" to={`/categories/${slide.id}`}>
                      <img src={slide.image} alt="slide" />
                      <span>{slide.name}</span>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
          <Link to={"/PopularCarsItems"} className="car-products">
            <img src="public/assets/index/purple-car.svg" alt="عکس" />
            <div>
              <span>محصولات مناسب ماشین من را پیدا کن</span>
            </div>
          </Link>
          <div className="categories" id="categories">
            <span>دسته بندی خدمات</span>
            <div className="service-container">
              <Swiper
                slidesPerView={"auto"}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay]}
                spaceBetween={12}
              >
                {service.map((slide) => (
                  <SwiperSlide key={slide.id}>
                    <Link className="service" to={`/services`}>
                      <span>{slide.title}</span>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
          <div className="request-product">
            <span>کالای مورد نیازتان را پیدا نکردید؟</span>
            <div onClick={() => setModal(true)}>
              <button className="button">ثبت درخواست قطعه</button>
            </div>
          </div>
          <div className="categories landingBlog">
            <div className="cat-header">
              <span>بلاگ کاچار</span>
              <div className="more">
                <span>مشاهده همه</span>
                <i className="icon-chevron-left" />
              </div>
            </div>
            <div>
              <Swiper
                slidesPerView={1.5}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay]}
                spaceBetween={12}
              >
                {data?.blog_posts?.map((slide) => (
                  <SwiperSlide key={slide.id}>
                    <div className="weblogCard">
                      <img src={slide.image} alt="slide" />
                      <p>{extractPurePersianWords(slide.description)}</p>
                      <div className="weblogCardFooter">
                        <span className="weblogCreatedTime">
                          {slide.created_at}
                        </span>
                        <a href={slide.link}>
                          <div>
                            <span>مشاهده بیشتر </span>
                            <i className="icon-chevron-left" />
                          </div>
                        </a>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
          <div className="navs">
            <Link to={"/mainPage"} className="nav-item">
              <img src="public/assets/index/store.svg" alt="عکس" />{" "}
              <span>فروشگاه</span>
            </Link>
            <div className="nav-seperate"></div>
            <Link to={"/services"} className="nav-item">
              <img src="public/assets/index/service.svg" alt="عکس" />{" "}
              <span>خدمات</span>
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default HomePage;
